module.exports = __webpack_public_path__ + "source/img/volume-on.a4b4837f.svg";